module.exports = __webpack_public_path__ + "img/1951_uk.6b00f33d.svg";